const isRecord = (value: unknown): value is Record<string, unknown> => typeof value === "object" && value !== null && !Array.isArray(value);

const stringField = (value: unknown, field: string): string | undefined => {
    if (!isRecord(value)) {
        return undefined;
    }
    const candidate = value[field];
    return typeof candidate === "string" ? candidate : undefined;
};

export type LoginFailureResolution = { kind: "verification-required" } | { kind: "error"; message: string };

export const resolveLoginFailure = (value: unknown, fallbackMessage: string): LoginFailureResolution => {
    if (isRecord(value) && value.verification_required === true) {
        return { kind: "verification-required" };
    }
    return { kind: "error", message: stringField(value, "error") ?? fallbackMessage };
};

export const responseStringField = stringField;

export interface MigrationSelection {
    provider: "google" | "microsoft";
    email: string;
    confirmationToken: string;
}

export const readMigrationSelection = (value: unknown): MigrationSelection | null => {
    if (!isRecord(value) || !isRecord(value.pending)) return null;
    const selection = value.pending;
    if (
        (selection.provider !== "google" && selection.provider !== "microsoft") ||
        typeof selection.email !== "string" ||
        !selection.email ||
        typeof selection.confirmation_token !== "string" ||
        !selection.confirmation_token
    )
        return null;
    return { provider: selection.provider, email: selection.email, confirmationToken: selection.confirmation_token };
};
